module.exports = __webpack_public_path__ + "img/Frutos Mumificados com Esporodóquios e Peritécios 1.b8e24dd6.webp";